import React, { useEffect, useRef } from "react";

const Challan = ({ widget }) => {
  const frame = useRef(null);

  const render = () => {
    const page = frame.current?.contentWindow;
    if (page?.Challan) page.Challan.render(widget.challanResult || { view: "drive" });
  };

  useEffect(render, [widget.challanResult]);

  return (
    <iframe
      ref={frame}
      title="challan"
      src={`${process.env.PUBLIC_URL || ""}/challan.html`}
      onLoad={render}
      style={{ width: "100%", height: "100%", border: 0, display: "block" }}
    />
  );
};

export default Challan;
